import { Flex, FlexProps } from '@chakra-ui/react'
import React from 'react'

export interface DefinitionListItemProps extends FlexProps {
  children: JSX.Element | JSX.Element[] | string | number
}

const DefinitionListItem = ({
  children,
  ...baseProps
}: DefinitionListItemProps) => {
  return (
    <Flex
      borderBottom="1px solid"
      borderBottomWidth={1}
      borderColor="gray.400"
      fontSize="sm"
      width="100%"
      padding=".5rem"
      {...baseProps}
    >
      {children}
    </Flex>
  )
}

export default DefinitionListItem
